import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import styles from './Countdown.module.scss';
const CountdownUnit = ({ label, value }) => {
    return (_jsxs("div", { children: [_jsxs("div", { className: styles.countdownValue, children: [value < 10 ? '0' : '', value] }), _jsx("div", { className: styles.countdownUnit, children: value !== 1 ? label.plural : label.single || label.plural })] }));
};
export { CountdownUnit };
